type EventBus = {
  _events: Record<string, Function[]>,
  dispatch: (evt: string, data?: any) => void;
  subscribe: (evt: string | string[], cbk: Function) => void;
  unsubscribe: (evt: string | string[]) => void;
}

export const EventEmitter: EventBus = {
  _events: {},
  dispatch: function (event: string, data?: any) {
    if (!this._events[event]) return;
    this._events[event].forEach(callback => callback(data))
  },
  subscribe: function (event: string | string[], callback: Function) {
    if (Array.isArray(event)) {
      event.forEach(evt => {
        if (!this._events[evt]) this._events[evt] = [];
        this._events[evt].push(callback);
      })
      return;
    }

    if (!this._events[event]) this._events[event] = [];
    this._events[event].push(callback);
  },
  unsubscribe: function (event: string | string[]) {
    if (Array.isArray(event)) {
      event.forEach(evt => {
        if (!this._events[evt]) return;
        delete this._events[evt];
      })
      return;
    }

    if (!this._events[event]) return;
    delete this._events[event];
  }
}